// const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
import { CognitoAuth, StorageHelper } from 'amazon-cognito-auth-js';
import axios from 'axios';
import IndexRouter from '../router/index';
const AWS = require('aws-sdk');
import store from '@/store';
import {
  clientIdAdmin,
  userPoolIdAdmin,
  appDomain,
  redirect,
  redirectSigout,
  REGION,
  IDENTITY_POOL_ID,
} from '@/utils/config';
import Vue from 'vue';
import { getMenu } from '@/api/Menu.api';
import jwtDecode from 'jwt-decode';

const CLIENT_ID = clientIdAdmin;
const APP_DOMAIN = appDomain;
const REDIRECT_URI = redirect;
const USERPOOL_ID = userPoolIdAdmin;
const REDIRECT_URI_SIGNOUT = redirectSigout;

var authData = {
  ClientId: CLIENT_ID, // Your client id here
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ['openid', 'email', 'profile'],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID,
};

var auth = new CognitoAuth(authData);
auth.useCodeGrantFlow();
function getUserInfoStorageKey() {
  var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
  var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo';
  return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();
async function getMenuList() {
  await getMenu().then(({ result }) => {
    store.menuList = result;
    Vue.ls.set('Menu_List', result);
  });
}

auth.userhandler = {
  onSuccess: function(authresult) {
    console.log(authresult);
    // PROVEDER_KEY作成
    const PROVIDER_KEY = 'cognito-idp.' + REGION + '.amazonaws.com/' + USERPOOL_ID;

    AWS.config.region = REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: IDENTITY_POOL_ID,
      Logins: {
        [PROVIDER_KEY]: authresult.getIdToken().getJwtToken(),
      },
    });

    this.loggedIn = true;
    console.log(auth.getSignInUserSession());
    var jwtToken = auth.getSignInUserSession().getIdToken().jwtToken;
    var jwtAccessToken = auth.getSignInUserSession().getAccessToken().jwtToken;
    let jwtTokenDecode = jwtDecode(jwtToken);
    let jwtAccessTokenDecode = jwtDecode(jwtAccessToken);
    let expireAt = jwtTokenDecode.exp;
    console.log('expireAt: ', expireAt);
    console.log('jwtTokenDecode: ', jwtTokenDecode);
    console.log('jwtToken: ', jwtAccessTokenDecode);
    const USERINFO_URL = 'https://' + auth.getAppWebDomain() + '/oauth2/userInfo';
    var requestData = {
      headers: {
        Authorization: 'Bearer ' + jwtAccessToken,
      },
    };
    
    Vue.$toast.clear();
    let alertGroupError = () => Vue.ls.set('error_group', 'お使いのアカウントでは利用できません。');
    if (!checkGroups(jwtTokenDecode['cognito:groups'])) return [auth.signOut(), alertGroupError()];

    return axios.get(USERINFO_URL, requestData).then(async ({ data }) => {
      await getMenuList();
      store.Auth.Authorization = jwtToken;
      store.Auth.userDetail = data;
      Vue.ls.set('Authorization', jwtToken);
      Vue.ls.set('userDetail', data);
      let refreshTo = Vue.ls.get('refreshTo');
      if (refreshTo) {
        IndexRouter.push(refreshTo).catch(() => console.error());
      } else {
        IndexRouter.push({ name: 'Version' }).catch(() => console.error());
      }
    });
  },
  onFailure: function(err) {
    console.error('err: ', err);
    this.loggedIn = false;
    this.cognitoInfo = {};
    logout();
  },
};

function checkGroups(groups) {
  return Boolean(groups.find((group) => group == 'CMS'));
}
function logout() {
  if (auth.isUserSignedIn()) {
    var userInfoKey = getUserInfoStorageKey();
    auth.signOut();
    Vue.ls.clear();
    store.Auth = {};
    storage.removeItem(userInfoKey);
  } else {
    auth.signOut();
    Vue.ls.clear();
  }
}
const mixin = {
  store: ['loggedIn', 'cognitoInfo', 'Auth'],
  data() {
    return {
      auth,
    };
  },

  methods: {
    handleLogout: logout,
    getUserInfoStorageKey,
  },
};

export default mixin;
